export var PASSWORD_REQUIRED = 'PASSWORD_REQUIRED';
export var VERIFY_PASSWORD = 'VERIFY_PASSWORD';
export var VERIFY_PASSWORD_FAIL = 'VERIFY_PASSWORD_FAIL';
// Success can be PASSWORD_VALID or PASSWORD_INVALID
export var PASSWORD_VALID = 'PASSWORD_VALID';
export var PASSWORD_INVALID = 'PASSWORD_INVALID';
